import validate from 'validate.js';
import { get } from 'lodash';

const validateBaseRate = (values) => {
  const {
    base_value,
    display_gratuity_percent,
    tax_percent
  } = get(values, 'prices', '');

  return {
    prices: {
      base_value: validate.single(base_value,
        {
          presence: { allowEmpty: false },
          numericality: {
            onlyInteger: true,
            greaterThan: 0
          }
        }),
      tax_percent: validate.single(tax_percent,
        {
          presence: { allowEmpty: false },
          numericality: true
        }),
      display_gratuity_percent: validate.single(display_gratuity_percent,
        {
          presence: { allowEmpty: false },
          numericality: true
        })
    }
  };
};

export default validateBaseRate;
